import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    cursor: 'pointer',
    margin: '0.5em',
    backgroundColor: 'var(--color-white)',
    border: '1px solid rgba(61, 30, 92, 0.05)',
    borderRadius: '24px',
    boxShadow: '0 6px 18px rgba(61, 30, 92, 0.06)',
    overflow: 'hidden',
    position: 'relative',
    transition: 'transform .25s ease, box-shadow .25s ease, border-color .25s ease',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      background: 'var(--gradient-festive)',
      opacity: 0,
      transition: 'opacity .25s ease',
    },
    '&:hover': {
      transform: 'translateY(-6px)',
      boxShadow: '0 22px 50px rgba(232, 72, 79, 0.18)',
      borderColor: 'rgba(255, 107, 107, 0.25)',
      opacity: 1,
    },
    '&:hover::after': {
      opacity: 1,
    },
    '&:hover $media': {
      transform: 'scale(1.04)',
    },
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
    backgroundSize: 'contain',
    backgroundColor: 'var(--color-pink-blush)',
    transition: 'transform .35s ease',
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '0.6rem',
    '& > h3': {
      fontFamily: 'Fraunces, serif',
      fontSize: '1.25rem',
      fontWeight: 600,
      color: 'var(--color-plum)',
      lineHeight: 1.2,
      letterSpacing: '-0.005em',
    },
  },
  iconButton: {
    textAlign: 'left',
    display: 'flex',
    color: 'var(--color-text-soft)',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.85rem',
    padding: '0.25rem 0',
    '& > * > *': {
      marginRight: '0.6rem',
    },
    '& svg': {
      fontSize: '1.05rem',
      color: 'var(--color-coral)',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      color: 'var(--color-plum)',
    },
  },
}));
